import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { statusType } from '../interfaces/enumStatusType';
interface MsgObject {
    text: string;
    headline?: string;
    type?: statusType;
}

@Injectable({
    providedIn: 'root'
})
export class SnackService {
    snackText = new BehaviorSubject<string>('');
    snackHeadline = new BehaviorSubject<string>('');
    showSnack = new BehaviorSubject<boolean>(false);
    type = new BehaviorSubject<statusType>(statusType.Info);
    constructor() { }

    async success(text: any): Promise<void> {
        let msg: MsgObject = text;
        if (text.msg) {
            msg = text.msg;
        } else {
            return;
        }

        if (!msg.headline || !msg.text) {
            return;
        }


        this.snackText.next(msg.text);
        this.snackHeadline.next(msg.headline || '');
        this.type.next(statusType.Success);
        this.showSnack.next(true);
    }
    async error(msgObject: any): Promise<void> {
        console.log(msgObject);

        let msg = msgObject;
        if (msg.error?.msg) {
            msg = msg.error.msg;
        } else if (msg.msg) {
            msg = msg.msg;
        } else {
            // Set default error message
            msg =
            {
                headline: 'Error',
                text: "An unexpected error occurred. Please try again later.",
            };
        }

        if (!msg.headline || !msg.text) {
            msg =
            {
                headline: 'Error',
                text: "An unexpected error occurred. Please try again later.",
            };
        }

        this.snackText.next(msg.text);
        this.snackHeadline.next(msg.headline);
        this.type.next(statusType.Error);
        this.showSnack.next(true);
    }
    async errorText(text: string): Promise<void> {
        this.snackText.next(text);
        this.snackHeadline.next("Error");
        this.type.next(statusType.Error);
        this.showSnack.next(true);
    }
    async warning(text: any): Promise<void> {
        let msg = text;
        if (msg.msg) msg = msg.msg;
        this.snackText.next(msg.text);
        this.snackHeadline.next(msg.headline);
        this.type.next(statusType.Warning);
        this.showSnack.next(true);
    }
    async info(text: any): Promise<void> {
        let msg = text;
        if (msg.msg) msg = msg.msg;
        this.snackText.next(msg.text);
        this.snackHeadline.next(msg.headline);
        this.type.next(statusType.Neutral);
        this.showSnack.next(true);
    }
    async close(): Promise<void> {
        this.showSnack.next(false);
    }
}
